import React from 'react';

const PoliciesAndFeesSection = () => (
  <div className='row'>
    <div>
      <h3>Activity Policies and Fees</h3>

      <h5>1. Cancellation Policy</h5>
      <p>
        Cancellations must be made at least 48 hours before the activity start
        time. Cancellations made within 48 hours will be refunded 50% of the
        total amount. No refunds will be given for same-day cancellations or
        no-shows.
      </p>

      <h5>2. Refund Policy</h5>
      <p>
        If the activity is canceled due to unforeseen circumstances or by the
        organizer, a full refund will be provided. Otherwise, refunds will be
        issued in accordance with the cancellation policy.
      </p>

      <h5>3. Safety Rules</h5>
      <p>
        All participants must follow the safety guidelines provided by the
        organizer and wear personal safety equipment (e.g., helmets, protective
        gear). Failure to comply with safety instructions may result in denied
        participation, and no refund will be issued.
      </p>

      <h5>4. Age Restrictions</h5>
      <p>
        This activity is suitable for participants aged 12 and above. Children
        under 12 must be accompanied by an adult, and participants under 18 will
        require a parent or legal guardian's consent.
      </p>

      <h5>5. Health Requirements</h5>
      <p>
        Participants with specific health conditions (e.g., heart conditions,
        high blood pressure, pregnancy) may be restricted from participating. It
        is the responsibility of the participant to assess their own health
        before joining, and the organizer will not be held liable for any
        health-related issues.
      </p>

      <h5>6. Reservation Change Policy</h5>
      <p>
        Reservation changes must be requested at least 24 hours before the
        activity start time. Any changes made within 24 hours may incur
        additional fees, and changes are subject to availability.
      </p>

      <h5>7. Time and Location</h5>
      <p>
        The activity will begin promptly at the designated time and location.
        Participants are required to arrive at least 15 minutes before the start
        time. Late arrivals may not be accommodated. The location may be subject
        to change, and participants will be notified in advance.
      </p>

      <h5>8. Additional Fees</h5>
      <p>
        Any additional services or upgrades requested during the activity may
        incur extra fees. These fees will be communicated upfront before the
        activity begins.
      </p>
    </div>
  </div>
);

export default PoliciesAndFeesSection;
